// extracted by mini-css-extract-plugin
module.exports = {"image":"CategoryTile_image__0ULSe","title":"CategoryTile_title__z8zED"};